// extracted by mini-css-extract-plugin
module.exports = {"hotelFacility":"HotelFacility_hotelFacility__Ex4CY","facilityTooltip":"HotelFacility_facilityTooltip__3bBMQ"};